import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { CFM_STONE } from 'constants/Colors';
import Button from '../Button';
import './styles.scss';

const ButtonTertiary = ({ classNames = [], children, icon, ...props }) => {
    const Icon = icon;

    const renderIcon = () => {
        if (typeof icon === 'string' || typeof icon === 'function') {
            return <Icon color={CFM_STONE} />;
        }
        if (typeof icon === 'object') {
            return icon;
        }
        return null;
    };

    return (
        <Button {...props} classNames={['custom-btn-tertiary', ...classNames]}>
            {icon ? (
                <Fragment>
                    <span className="custom-btn-tertiary__text">{children}</span>
                    <i className="custom-btn-tertiary__icon">{renderIcon()}</i>
                </Fragment>
            ) : (
                { children }
            )}
        </Button>
    );
};

ButtonTertiary.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default ButtonTertiary;
